var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReservationX2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.67276 5.14282H5.51538H18.5267C19.3591 5.14282 20.0712 5.74076 20.2152 6.56059L22.0215 16.8463C22.2058 17.8956 21.3984 18.8571 20.333 18.8571H6.47907C5.64669 18.8571 4.9346 18.2592 4.79062 17.4393L4.73855 17.1428H2.80155C1.74069 17.1428 0.931913 16.1856 1.11609 15.1371C1.41977 13.4082 1.67295 12.1844 1.92407 10.9707L1.92408 10.9706L1.9448 10.8705C2.20216 9.62636 2.45918 8.37637 2.77212 6.57029C2.91395 5.7518 3.6237 5.14282 4.46419 5.14282H4.67276ZM4.4375 15.4285L3.66382 11.023C3.65038 11.088 3.63696 11.1529 3.62354 11.2178L3.60343 11.315L3.60342 11.315C3.35278 12.5265 3.1042 13.728 2.80542 15.4285H4.4375ZM5.51538 6.85711H18.5267L20.333 17.1428L6.47907 17.1428L4.67276 6.85711L5.51538 6.85711ZM7.45312 11.1428C7.45312 10.6695 7.83688 10.2857 8.31027 10.2857H16.6954C17.1687 10.2857 17.5525 10.6695 17.5525 11.1428C17.5525 11.6162 17.1687 12 16.6954 12H8.31027C7.83688 12 7.45312 11.6162 7.45312 11.1428Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationX2);
export default __webpack_public_path__ + "static/media/ReservationX2.9e3a458951bc4a05be5a7a28dae780fe.svg";
export { ForwardRef as ReactComponent };